export default "__VITE_ASSET__DOAaHdXK__"